import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import history from '~/services/history';
import api from '~/services/api';

import { saveCcr5Failure, saveCcr5Success, updateCcr5Failure, updateCcr5Success } from './actions';

export function* saveCcr5({ payload }) {
  try {
    yield call(api.post, 'api/ccr5', payload.data, { withCredentials: true });

    yield put(saveCcr5Success());

    toast.success('CCR5 criado com sucesso!')

    history.push('/specifications/pilar3/resources/ccr5');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(saveCcr5Failure());
  }
}

export function* updateCcr5({ payload }) {
  try {
    const { id } = payload.data;
    yield call(api.post, `api/ccr5/${id}`, payload.data, { withCredentials: true });

    yield put(updateCcr5Success());

    toast.success('CCR5 atualizado com sucesso!')

    history.push('/specifications/pilar3/resources/ccr5');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(updateCcr5Failure());
  }
}

export default all([
  takeLatest('@ccr5/SAVE_REQUEST', saveCcr5),
  takeLatest('@ccr5/UPDATE_REQUEST', updateCcr5)
]);